export function ProgressionBar({ step }: { step: number }) {
  return (
    <div className="h-3 w-[96%] mx-auto absolute  top-2 rounded-full overflow-hidden bg-stone-100 flex gap-1  ">
      <div className="h-full w-[33%] transition-all duration-300 bg-brow-main " />
      <div
        className={`h-full w-[33%] transition-all duration-300 ${
          step > 1 ? "bg-brow-main" : "bg-stone-200"
        } `}
      />
      <div
        className={`h-full w-[33%] transition-all duration-300 ${
          step > 2 ? "bg-brow-main" : "bg-stone-200"
        } `}
      />
      {/* <div
        className={`h-full w-[25%] transition-all duration-300 ${
          step > 3 ? "bg-brow-main" : "bg-stone-200"
        } `}
      /> */}
    </div>
  );
}
